/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  CumprirCompromissoAvulsoMutationRequest,
  CumprirCompromissoAvulsoMutationResponse,
  CumprirCompromissoAvulso401,
} from '../../types/CumprirCompromissoAvulso.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getCumprirCompromissoAvulsoUrl() {
  const res = {
    method: 'POST',
    url: `/compromisso-avulso/cumprir-compromisso-avulso` as const,
  };
  return res;
}

/**
 * @description Cumpre compromissos avulsos existentes
 * @summary Cumprir compromisso avulso
 * {@link /compromisso-avulso/cumprir-compromisso-avulso}
 */
export async function cumprirCompromissoAvulso(
  data?: CumprirCompromissoAvulsoMutationRequest,
  config: Partial<RequestConfig<CumprirCompromissoAvulsoMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    CumprirCompromissoAvulsoMutationResponse,
    ResponseErrorConfig<CumprirCompromissoAvulso401>,
    CumprirCompromissoAvulsoMutationRequest
  >({
    method: 'POST',
    url: getCumprirCompromissoAvulsoUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
